import type { Messages } from '../en'

export const shell: Messages['shell'] = {
  navHome: 'Início',
  navFlows: 'Fluxos',
  navActive: 'Execuções ativas',
  navMemories: 'Memórias',
  navAccess: 'Acessos',
  navTenants: 'Empresas',
  navHistory: 'Histórico',
  signOut: 'Sair',
  switchCompany: 'Empresa',
  switchCompanyFailed: 'Não foi possível trocar de empresa. Tente novamente.',
  toggleNavigation: 'Abrir ou fechar a navegação'
}
